import { useState, useRef } from 'react'
import { useDebounceFn } from 'ahooks'
import { Input } from 'antd-mobile'
import { SearchOutline, CloseOutline } from 'antd-mobile-icons'
import { Transition } from 'react-transition-group'
import { utils } from '@/utils'
import './index.less'

const { px2rem } = utils
const duration = 600;
const defaultStyle = {
  transition: `all ${duration}ms ease-in-out`,
  boxSizing: 'border-box',
  width: 0,
}

interface IProps {
  value: string
  width?: string
  placeholder?: string
  onChange(value: string): void
}

function FlexSearch(props: IProps) {
  const { value, placeholder = '', width = '100%' } = props
  const [showInput, setShowInput] = useState(false)
  const inputRef = useRef<any>(null)

  const padding = `${px2rem(12)} ${px2rem(18)} ${px2rem(12)} ${px2rem(32)}`
  const transitionStyles: any = {
    entering: { width: width, padding, borderWidth: '1px', },
    entered:  { width: width, padding, borderWidth: '1px', },
    exiting:  { width: 0, padding: '0', borderWidth: '0', },
    exited:  { width: 0, padding: '0', borderWidth: '0', },
  };

  const { run: onSearchChange } = useDebounceFn(
    (value) => {
      props.onChange(value)
    },
    {
      wait: 30,
    },
  )

  function onClear() {
    props.onChange('')
  }

  function toggleInput() {
    const _showInput = !showInput
    setShowInput(_showInput)
    if (_showInput) {
      setTimeout(() => {
        inputRef.current?.focus()
      })
    }
  }

  return (
    <div className="search-component">
      {
        !showInput &&
        <SearchOutline className="search-icon"
          fontSize={ 24 }
          onClick={ toggleInput }
        />
      }
      {
        showInput &&
        <CloseOutline className="search-icon"
          fontSize={ 24 }
          onClick={ toggleInput }
        />
      }

      <Transition in={ showInput } timeout={ duration }>
        {(state: any) => (
          <Input
            className="search-input"
            ref={ inputRef }
            model-value={ value }
            clearable
            clear-trigger="always"
            placeholder={ placeholder }
            style={{
              ...defaultStyle,
              ...transitionStyles[state]
            }}
            onChange={ onSearchChange }
            onClear={ onClear }
          />
        )}
      </Transition>
    </div>
  )
}

export default FlexSearch